export default __webpack_public_path__ + "static/logo-e976c03943d2f854e30dcbf32115f5c9.svg";